export default {
  typeSelect: {
    width: '100%',
    background: '#fff'
  }
}
